import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import id from '@angular/common/locales/id';
import { registerLocaleData, APP_BASE_HREF } from '@angular/common';
import { NgZorroAntdModule, NZ_I18N, id_ID, NzIconModule, NzFormModule } from 'ng-zorro-antd';
import { TokenInterceptorService } from '~common/interceptor/token-interceptor.service';
import { LoaderInterceptorService } from '~common/interceptor/loader-interceptor.service';
import { NotFoundComponent } from '~shared/not-found/not-found.component';
import { AppComponent } from './app.component';
import { IconsProviderModule } from '~shared/icons-provider/icons-provider.module';
import { LayoutModule } from '~layout/layout.module';
import { ElementModule } from '~shared/element/element.module';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CultureInterceptor } from '~common/interceptor/culture.interceptor';
import { TimezoneInterceptorService } from '~common/interceptor/timezone-interceptor.service';
import { LoginComponent } from './module/shared/login/login.component';
import { MsalBroadcastService, MsalModule, MsalService, MSAL_INSTANCE, MsalRedirectComponent } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

registerLocaleData(id);
// sessionStorage.setItem(CULTURE_INFO, JSON.stringify('id-ID'));

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      authority: environment.authority,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: environment.postLogoutRedirectUri,
      navigateToLoginRequestUrl: true
    }
  });
}

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    IconsProviderModule,
    NgZorroAntdModule,
    NzFormModule,
    NzIconModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ElementModule,
    LayoutModule,
    MsalModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    {
      provide: NZ_I18N,
      useValue: id_ID
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CultureInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimezoneInterceptorService,
      multi: true
    },
    {
      provide: APP_BASE_HREF, useValue: '/'
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    MsalService,
    MsalBroadcastService,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
